/**
 * The single implementation of "is this an Inhouse email?" — previously
 * computed inline in four places (HomeSlice reducer, FileAttachmentPrompt,
 * AttachmentStatusMessage, ChatBoxComponent) with identical logic.
 *
 * NOTE: deliberately separate from useInhouseStaffGate, which matches ONLY
 * @inhouse.ai for security-relevant staff gating — see that hook's header for
 * why the broader three-domain match must not be reused there.
 *
 * Roadmap: docs/domain-refactor-roadmap.md (Module 8).
 */
import { INHOUSE_DOMAINS } from "src/constants/inhouse";

export const isInhouseEmail = (email: string | null | undefined): boolean =>
  !!email && INHOUSE_DOMAINS.some((domain) => email.endsWith(domain));
